import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["testId", "url", "renderers"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from 'react';
import { di } from 'react-magnetic-di';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import useRelatedUrls from '../../../../../state/hooks/use-related-urls';
import { RelatedUrlsBlockErroredView } from './errored';
import { RelatedUrlsResolvedView } from './resolved';
import { RelatedUrlsBlockResolvingView } from './resolving';
import { fireRelatedLinksLoadedEvent } from './analytics';
/**
 * Represents a block to display related resources of a url
 */
var RelatedUrlsBlock = function RelatedUrlsBlock(_ref) {
  var _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'smart-block-related-urls' : _ref$testId,
    url = _ref.url,
    renderers = _ref.renderers,
    blockProps = _objectWithoutProperties(_ref, _excluded);
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    loadingRelatedUrls = _useState2[0],
    setLoadingRelatedUrls = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    err = _useState4[0],
    setErr = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    relatedUrls = _useState6[0],
    setRelatedUrls = _useState6[1];
  var getRelatedUrls = useRelatedUrls();
  useEffect(function () {
    var fetchRelatedUrls = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _relUrls$resolvedResu, _relUrls$resolvedResu2, relUrls;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return getRelatedUrls(url);
            case 3:
              relUrls = _context.sent;
              setRelatedUrls(relUrls);

              /**
               * Fire TrackRelatedLinksLoadedEvent
               */
              fireRelatedLinksLoadedEvent(createAnalyticsEvent)({
                relatedLinksCount: (_relUrls$resolvedResu = (_relUrls$resolvedResu2 = relUrls.resolvedResults) === null || _relUrls$resolvedResu2 === void 0 ? void 0 : _relUrls$resolvedResu2.length) !== null && _relUrls$resolvedResu !== void 0 ? _relUrls$resolvedResu : 0
              });
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              setErr(_context.t0);
            case 11:
              setLoadingRelatedUrls(false);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 8]]);
      }));
      return function fetchRelatedUrls() {
        return _ref2.apply(this, arguments);
      };
    }();
    fetchRelatedUrls();
  }, [createAnalyticsEvent, getRelatedUrls, url]);
  if (loadingRelatedUrls) {
    return /*#__PURE__*/React.createElement(RelatedUrlsBlockResolvingView, _extends({
      testId: "".concat(testId, "-resolving-view")
    }, blockProps));
  }
  if (relatedUrls) {
    return /*#__PURE__*/React.createElement(RelatedUrlsResolvedView, _extends({
      renderers: renderers,
      overrideCss: css({
        minHeight: '1.55rem'
      }),
      testId: "".concat(testId, "-resolved-view"),
      relatedUrlsResponse: relatedUrls
    }, blockProps));
  }
  return /*#__PURE__*/React.createElement(RelatedUrlsBlockErroredView, _extends({
    err: err,
    testId: "".concat(testId, "-errored-view")
  }, blockProps));
};
export default RelatedUrlsBlock;